import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { brokerApi } from './api';

export default function ConnectBroker() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [apiKey, setApiKey] = useState('');
  const [apiSecret, setApiSecret] = useState('');
  const [environment, setEnvironment] = useState('paper');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    brokerApi.status().then(setStatus).catch(() => setStatus({ connected: false }));
  }, []);

  const handleConnect = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const result = await brokerApi.connect(apiKey, apiSecret, environment);
      setStatus(result);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnect = async () => {
    await brokerApi.disconnect();
    setStatus({ connected: false });
  };

  return (
    <div className="auth-screen">
      <div className="auth-card broker-card">
        <div className="auth-brand">QuantumTrade</div>
        <h1 className="auth-title">Connect your brokerage</h1>
        <p className="auth-subtitle">
          Trades placed here execute through your own Alpaca account. Your API keys are encrypted at rest and
          never shared with other users.
        </p>

        {status?.connected ? (
          <div className="broker-status-card">
            <div className="status-row">
              <span className={`status-pill ${status.environment}`}>{status.environment.toUpperCase()}</span>
              <span>Connected since {new Date(status.connectedAt).toLocaleDateString()}</span>
            </div>
            <div className="broker-actions">
              <button className="secondary-button" onClick={() => navigate('/')}>
                Go to dashboard
              </button>
              <button className="danger-link" onClick={handleDisconnect}>
                Disconnect account
              </button>
            </div>
          </div>
        ) : (
          <form className="auth-form" onSubmit={handleConnect}>
            <div className="input-group">
              <label>Trading mode</label>
              <div className="segmented-control">
                <button
                  type="button"
                  className={environment === 'paper' ? 'active' : ''}
                  onClick={() => setEnvironment('paper')}
                >
                  Paper (simulated)
                </button>
                <button
                  type="button"
                  className={environment === 'live' ? 'active' : ''}
                  onClick={() => setEnvironment('live')}
                >
                  Live (real money)
                </button>
              </div>
              {environment === 'live' && (
                <small className="input-hint warning">
                  Live mode places real orders with real funds. Make sure you've tested in paper mode first.
                </small>
              )}
            </div>

            <div className="input-group">
              <label>Alpaca API Key ID</label>
              <input type="text" value={apiKey} onChange={(e) => setApiKey(e.target.value)} required autoFocus />
            </div>
            <div className="input-group">
              <label>Alpaca API Secret Key</label>
              <input type="password" value={apiSecret} onChange={(e) => setApiSecret(e.target.value)} required />
            </div>

            {error && <div className="error-box">{error}</div>}

            <button type="submit" className="primary-button" disabled={loading}>
              {loading ? 'Verifying…' : 'Connect account'}
            </button>
            <button type="button" className="secondary-button" onClick={() => navigate('/')}>
              Skip for now
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
